import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppConstants } from 'src/app/app.constants';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-product-specifications',
  templateUrl: './product-specifications.component.html',
  styleUrls: ['./product-specifications.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor]
})
export class ProductSpecificationsComponent implements OnChanges {
  firstObj = this.appConstants.firstObj;
  specificationsdata: {
    heading: SafeHtml;
    rows: { left: string; right: string }[];
  }[] = [];

  @Input() selectedSkuSpecifications: any[] = [];

  constructor(
    private appConstants: AppConstants,
    private sanitizer: DomSanitizer,
    private browser: BrowserService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedSkuSpecifications']?.currentValue) {
      this.getSpecificationsLabelAndValues();
    }
  }

  getSpecificationsLabelAndValues() {
    this.specificationsdata = [];
    const data = this.selectedSkuSpecifications?.[this.firstObj];
    if (!data) return;
    Object.entries(data).forEach(([key, value]) => {
      if (!key.startsWith('specification_label')) return;
      const index = key.replace('specification_label', '');
      const valueKey = `specification_value${index}`;
      const labelHtml = String(value || '');
      const valueHtml = String(data[valueKey] || '');
      const headingMatch = labelHtml.match(/<h3[\s\S]*?<\/h3>/i);
      const heading = headingMatch ? headingMatch[0] : '';
      let rows: { left: string; right: string }[] = [];
      const hasHtmlList =
        /<li[\s\S]*?>/i.test(labelHtml) ||
        /<li[\s\S]*?>/i.test(valueHtml);
      if (hasHtmlList) {
        const liFromLabel = labelHtml.match(/<li[\s\S]*?<\/li>/gi) || [];
        const liFromValue = valueHtml.match(/<li[\s\S]*?<\/li>/gi) || [];
        rows = [...liFromLabel, ...liFromValue].map(li => {
          let text = li.replace(/<\/?[^>]+>/g, '').trim();
          text = this.normalizeText(text);
          text = text.replace(/:+/g, ':');
          const colonIndex = text.indexOf(':');
          if (colonIndex !== -1) {
            return {
              left: text.substring(0, colonIndex).trim(),
              right: text.substring(colonIndex + 1).trim()
            };
          }
          return { left: text, right: '' };
        });
      } else if (labelHtml || valueHtml) {
        const parseJsonLike = (str: string) => {
          const result: { left: string; right: string }[] = [];
          if (!str) return result;
          const cleanStr = str.trim();
          try {
            if (cleanStr.startsWith('{') && cleanStr.endsWith('}')) {
              const parsed = JSON.parse(cleanStr);
              Object.entries(parsed).forEach(([k, v]) => {
                result.push({
                  left: this.normalizeText(k),
                  right: this.normalizeText(String(v))
                });
              });
              return result;
            }
            cleanStr.split(',').forEach(pair => {
              const [k, v] = pair.split(':');
              if (k && v) {
                result.push({
                  left: this.normalizeText(k.replace(/"/g, '').replace(/[{}]/g, '').trim()),
                  right: this.normalizeText(v.replace(/"/g, '').trim())
                });
              }
            });
          } catch (e) {
            console.warn('Parsing failed:', cleanStr, e);
          }
          return result;
        };
        const labelRows = parseJsonLike(labelHtml);
        const valueRows = parseJsonLike(valueHtml);
        rows = [...labelRows, ...valueRows];
      }
      this.specificationsdata.push({
        heading: this.sanitizer.bypassSecurityTrustHtml(heading),
        rows
      });
    });
  }

  normalizeText(text: string): string {
    return this.decodeHtml(text)
      .replace(/Ã—/g, '×')
      .replace(/\s+/g, ' ')
      .trim();
  }

  decodeHtml(text: string): string {
    if (!text) return '';
    if (!this.browser.isBrowser) return text;
    const textarea = this.browser.doc?.createElement('textarea');
    if (!textarea) return text;
    textarea.innerHTML = text;
    return textarea.value;
  }
}